module.exports = __webpack_public_path__ + "img/world.cea30ed8.svg";